<template>
  <div
    id="DoughnutChart"
    style="width: 100%; height: 55vh"
    data-echart-responsive="true"
  ></div>
</template>
<script>
import * as echarts from "echarts";
export default {
  name: "DoughnutChart",
  props: { doughnutData: Object },
  data: function () {
    return {};
  },
  watch: {
    doughnutData() {
      var chartDom = document.getElementById("DoughnutChart");
      var myChart = echarts.init(chartDom);
      myChart.setOption(this.option);
      myChart.resize();
    },
  },
  mounted() {
    if (Object.keys(this.doughnutData).length !== 0) {
      var chartDom = document.getElementById("DoughnutChart");
      var myChart = echarts.init(chartDom);
      myChart.setOption(this.option);
      myChart.resize();
    }
  },
  computed: {
    candidates() {
      return this.$store.getters["Home/candidateStats"];
    },
    data() {
      const data = this.doughnutData.data;
      const backgroundColor = this.doughnutData.backgroundColor;
      return data
        .map((el, i) => {
          const obj = { itemStyle: {} };
          obj.value = el;
          obj.name = this.doughnutData.labels[i];
          obj.itemStyle.color = backgroundColor[i];
          return obj;
        })
        .sort(function (a, b) {
          return a.value - b.value;
        });
    },
    option() {
      return {
        title: {
          text: this.doughnutData.title,
          left: "center",
          top: 10,
          textStyle: {
            color: "#000",
          },
        },
        labelLine: {
          show: false,
          lineStyle: {
            length: 1,
            length2: 5,
            smooth: 0.7,
          },
        },
        radius: ["30%", "60%"],
        grid: { containLabel: true },
        tooltip: {
          trigger: "item",
        },
        visualMap: {
          show: false,
          min: 80,
          max: 600,
          inRange: {
            colorLightness: [0, 1],
          },
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: [30, 60],
            center: ["50%", "50%"],
            roseType: "area",
            itemStyle: {
              borderRadius: 8,
            },
            data: this.data,
          },
        ],
      };
    },
  },
};
</script>
